module.exports = __webpack_public_path__ + "static/img/bg-id.bed57eb1.png";